module.exports = __webpack_public_path__ + "img/001-schedule.ce75335f.svg";